import React, { useState } from 'react';

interface listItems {
  id: number;
  text: string;
  subTitle: string;
}

export interface OptionsQuestionBasic {
  id: number;
  title: string;
  title2?: string;
  subtitle?: React.ReactElement | string;
  subtitleBold?: string;
  dropdown?: React.ReactElement | any;
  onClick: Function | null;
  textRight?: String | null;
  textHover?: String | null;
  hidden?: Function;
  icon?: any;
  styleActive?: 'option-active-blue' | 'option-active-purpure' | string;
  styleHover?: 'option-hover-blue' | 'option-hover-purpure' | string;
  customClass?: string;
  showChildrenOnHover?: boolean;
  icons?: any[];
  active?: boolean;
  disabled?: boolean;
}

interface Props {
  question: React.ReactElement;
  options: OptionsQuestionBasic[];
  listItems?: listItems[] | null;
  type: string | null;
  text?: React.ReactElement | null;
  optionSelected?: any;
  metadata?: any;
  disabled?: boolean;
}

const QuestionBasic = ({
  question,
  options,
  listItems,
  type,
  text,
  optionSelected,
  metadata,
  disabled
}: Props) => {
  const [isOptionSelected, setOptionSelected] = useState(optionSelected || 0);
  const [isHoverActive, setHoverActive] = useState<number>();
  const [isProcessing, setIsProcessing] = useState(false);

  const handleFInish = (option: any) => {
    if (!disabled && !isProcessing) {
      setIsProcessing(true);
      setOptionSelected(option.id);
      option.onClick(option, metadata);

      setTimeout(() => {
        setIsProcessing(false);
      }, 500)
    }
  };

  return (
    <div className="QuestionBasic">
      {question}
      <div className="mt-10">{text && text}</div>
      {listItems && (
        <ol className="list">
          {listItems?.map((item) => (
            <li className="h4" key={item.id}>
              <span>{item.subTitle}</span>{' '}
              <span className="h4-w4">{item.text}</span>
            </li>
          ))}
        </ol>
      )}
      <div className="options">
        {options?.map((option) =>
          !option.hidden || (option.hidden && !option.hidden(optionSelected)) ? (
            <div
              className={`Button-option ${option.customClass} ${option.styleHover} ${option.active && 'option-active-blue'} ${isOptionSelected === option.id && option.styleActive} ${(disabled || option.disabled) && 'disabled'}`}
              onClick={() => option.disabled? null: handleFInish(option)}
              onMouseEnter={() => setHoverActive(option.id)}
              onMouseLeave={() => setHoverActive(undefined)}
              key={option.id}
            >
              <div className={option.textRight ? "flex-btw" : "flex-btw wide"}>
                <div className="content-left">
                  <label className='h4 Button-option-text'>
                    <span className='title-span'>
                      {option.title}
                      {option.title2 &&
                        <div style={{ marginTop: 10 }}>
                          {option.title2}
                        </div>
                      }
                    </span>
                    {option.title === "No" &&
                      <span className='sub-title-no'>
                        <br />
                        We only do investment-purpose loans. That means you’ll need a legal entity to borrow with us. It’s ok if you don’t have one yet, but we do need to run a background and credit check on anyone who is going to be a personal guarantor on a loan.
                      </span>
                    }
                    {isHoverActive === option.id && option.showChildrenOnHover && option.textHover && option.id !== isOptionSelected && option.textHover}
                  </label>

                  <span className="Button-option-active-description">
                    {option.icon &&
                      <>
                        <img src={option.icon} className="lienzo" alt="lienzoSvg" />
                        {' '}
                      </>
                    }
                    {option.icons &&
                      <div className='icons-container'>
                        {option.icons.map((icon, index) => (
                          <img key={index} src={icon} className="lienzo" alt="lienzoSvg" />
                        ))}
                        {' '}
                      </div>
                    }
                    <span className='bold-little'>{option.subtitleBold}{' '}</span>
                    <span className='body-regular'>{option.subtitle}</span>
                  </span>
                </div>
                {option.textRight && (
                  <p className="body-regular body-regular-w5">
                    {option.textRight}
                  </p>
                )}
              </div>
              {type === 'dropdown' &&
                option.dropdown &&
                option.id === isOptionSelected &&
                option.dropdown(metadata)
              }
              {isHoverActive === option.id && option.dropdown && option.showChildrenOnHover && option.id !== isOptionSelected &&
                option.dropdown(metadata)
              }
            </div>
          ) : null
        )}
      </div>
    </div>
  );
};
export default QuestionBasic;
